import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';
import QuestionResult from '../question_result';
import './index.scss';

const DATA_PER_LOAD = 10;

const QuestionResultsList = ({ legalAdvicePage, data }) => {
    const [loadedData, setLoadedData] = useState([]);
    const [remainingData, setRemainingData] = useState([]);

    const loadMoreData = () => {
        setLoadedData([
            ...loadedData,
            ...remainingData.slice(0, DATA_PER_LOAD),
        ]);

        setRemainingData(remainingData.slice(DATA_PER_LOAD));
    };

    const handleLazyLoad = (inView) => {
        if (!inView) {
            return;
        }

        if (remainingData.length > 0) {
            loadMoreData();
        }
    };

    // Reset the state on data change
    useEffect(() => {
        setLoadedData([]);
        setRemainingData(data);
    }, [data]);

    // Load initial data if there's nothing loaded
    useEffect(() => {
        if (loadedData.length === 0 && remainingData.length > 0) {
            loadMoreData();
        }
    }, [loadedData, remainingData]);

    return (
        <>
            <div className="legal-advice-question-results-list">
                {loadedData.map((questionData) => (
                    <QuestionResult legalAdvicePage={legalAdvicePage} key={questionData.id} data={questionData} />
                ))}
            </div>

            <InView onChange={handleLazyLoad} />
        </>
    );
};

export default QuestionResultsList;
